import React, { useState } from "react";
import styles from "./../styles.css";
import ComprehensiveServiceCheck from "../../../shared/comprehensive-service-check";
import CarServicingDidYouKnowCard from "../../../shared/cars24-cover-pitching/car-servicing-did-you-know-card";
import BestPriceGuaranteed from "../../../shared/best-price-guaranteed";
import CarServicingHappyCustomerCard from "../../../shared/cars24-cover-pitching/car-servicing-happy-customer-card";
import PropTypes from "prop-types";
import WarrantyModal from "../../post-payment-journey/add-ons-plans/warranty-modal/component";
import locationIcon from "../images/location.svg";
import { VAS_CATEGORY_KEYS } from "../../../../constants/checkout-constants";
import ServicingCarCoveredCard from "../../servicing-car-covered-card/component";

export const TopServicePitch = ({ servicingLocation, carCoverMetadata }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const {
        subTitle = "",
        itemCheckInfo = {},
        marketingData = {},
        infoCard = {},
        info = ""
    } = carCoverMetadata || {};

    const handleWhyUsModal = () => {
        setIsModalOpen(!isModalOpen);
    };
    return (
        <div styleName={"styles.outer"}>
            <p styleName={"styles.servicingHeading"}>CARS24 Servicing</p>
            <p styleName={"styles.servicingSubHeading"}>{subTitle}</p>

            {info && (
                <div styleName={"styles.cardOuter"}>
                    <ServicingCarCoveredCard info={info} />
                </div>
            )}

            {itemCheckInfo && (
                <div styleName={"styles.comprehensiveOuter"}>
                    <ComprehensiveServiceCheck benefits={itemCheckInfo} onModalOpen={() => handleWhyUsModal()} />
                </div>
            )}

            {infoCard && (
                <div styleName={"styles.youKnow"}>
                    <CarServicingDidYouKnowCard {...infoCard} />
                </div>
            )}

            {marketingData &&
                <BestPriceGuaranteed marketingData={marketingData} />
            }

            <div styleName={"styles.chooseYourPlanWrapper"}>
                <p styleName={"styles.chooseYourPlan"}>
                Choose your plan
                </p>
                <p styleName={"styles.chooseYourPlanSubHeading"}>
                    {subTitle}
                </p>
            </div>

            <WarrantyModal
                isOpen={isModalOpen}
                planKey={VAS_CATEGORY_KEYS.CAR_SERVICING}
                onClose={() => setIsModalOpen(false)}
                isWhatsCovered={false}
                isPitching={true}
                servicingLocation={servicingLocation}
            />
        </div>
    );
};

TopServicePitch.propTypes = {
    setWhyUsModal: PropTypes.func,
    servicingLocation: PropTypes.string,
    carCoverMetadata: PropTypes.object
};

export const BottomServicePitch = ({ servicingLocation, carCoverMetadata }) => {
    const { promotionData } = carCoverMetadata || {};

    return (
        <div styleName={"styles.bottomContainer"}>
            {promotionData && <CarServicingHappyCustomerCard promotionData={promotionData} />}
            <div styleName={"styles.bottomCard"}>
                <p styleName={"styles.serviceCenter"}>CARS24 service center</p>
                <p styleName={"styles.dropOff"}>Drop off your car at the service centre and we’ll do the rest.</p>
                <p styleName={"styles.location"}>
                    <img src={locationIcon} alt="Location icon" />
                    {servicingLocation}
                </p>
            </div>
        </div>
    );
};

BottomServicePitch.propTypes = {
    servicingLocation: PropTypes.string,
    carCoverMetadata: PropTypes.object
};
